import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Form } from 'react-bootstrap';
import Toggle from 'react-toggle';
import Loader from '../loader/Loader';
import { Server } from '../../services/Server';

export default class SettingsModal extends Component {
  /*
    This component shows a modal with user settings
  */

  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    };
    this.loadSettings();
  }

  setSettings = settings => {
    if (!settings.email) {
      // eslint-disable-next-line no-param-reassign
      settings.email = '';
    }
    this.setState({
      settings,
      loaded: true
    });
  };

  loadSettings = async () => {
    const settings = await Server.loadSettings();
    this.setSettings(settings);
  };

  updateVisibility = e => {
    const { settings } = this.state;
    settings.visibility = e.target.checked ? 1 : 0;
    this.setState({
      settings
    });
  };

  updateNotify = e => {
    const { settings } = this.state;
    settings.notify = e.target.checked ? 1 : 0;
    this.setState({
      settings
    });
  };

  emailChange = e => {
    const { settings } = this.state;
    settings.email = e.target.value;
    this.setState({
      settings
    });
  };

  handleSubmit = async e => {
    e.preventDefault();
    this.setState({ loaded: false });
    const settings = await Server.updateSettings(this.state.settings);
    this.setSettings(settings);
  };

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.close}>
        <Form horizontal onSubmit={this.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Innstillinger</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loaded ? (
              <div>
                <label className="toggle-wrapper" htmlFor="visibility">
                  <Toggle
                    defaultChecked={!!this.state.settings.visibility}
                    onChange={this.updateVisibility}
                    id={'visibility'}
                  />
                  <span>
                    La din portefølje være synlig for andre på medlemssiden
                  </span>
                </label>
                <label className="toggle-wrapper" htmlFor="notify">
                  <Toggle
                    defaultChecked={!!this.state.settings.notify}
                    onChange={this.updateNotify}
                    id={'notify'}
                  />
                  <span>Motta ukentlige rapporter på mail</span>
                </label>
                <div>
                  <label htmlFor="email">E-postadresse</label>
                  <input
                    type="email"
                    value={this.state.settings.email}
                    onChange={this.emailChange}
                    className="form-control"
                  />
                </div>
              </div>
            ) : (
              <Loader />
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" href="/logg-ut">
              Logg ut
            </Button>
            <Button variant="light" onClick={this.props.close}>
              Lukk
            </Button>
            <Button variant="success" type="submit">
              Lagre
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

SettingsModal.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func
};
